import {defineStore} from "pinia";
import GUIActionResult = namaTypes.GUIActionResult;

export const useLoginInfoStore = defineStore("loginInfo", {
  state: () => ({
    isLoggedIn: false,
    loginInfo: null as namaTypes.CurrentLoginInfo | null,
    notifications: null as Array<namaTypes.DTOTabularResult> | null,
    notificationsCount: 0,
    approvals: null as Array<namaTypes.DTOTabularResult> | null,
    approvalsCount: 0,
    tasks: null as Array<GUIActionResult> | null | undefined,
    tasksCount: 0,
    chatMessagesCounts: 0,
    qrCodeDialogVisible: false
  }),
  actions: {
    login(loginInfo: namaTypes.CurrentLoginInfo) {
      this.loginInfo = loginInfo;
      this.isLoggedIn = true;
    },
    updateNotifications(notifications: Array<namaTypes.DTOTabularResult>, notificationsCount: number) {
      this.notifications = notifications;
      this.notificationsCount = notificationsCount;
    },
    updateApprovals(approvals: Array<namaTypes.DTOTabularResult>, approvalsCount: number) {
      this.approvals = approvals;
      this.approvalsCount = approvalsCount;
    },
    updateTasks(tasks: Array<GUIActionResult>, tasksCount: number) {
      this.tasks = tasks;
      this.tasksCount = tasksCount ?? 0;
    },
    updateChatMessages(chatMessagesCounts: number) {
      this.chatMessagesCounts = chatMessagesCounts ?? 0;
    },
    logout() {
      this.loginInfo = null;
      this.notifications = null;
      this.notificationsCount = 0;
      this.approvals = null;
      this.approvalsCount = 0;
      this.tasks = null;
      this.tasksCount = 0;
      this.isLoggedIn = false;
    }
  }
})
